const json = [
  {
    featureType: "land",
    elementType: "all",
    stylers: {
      color: "#1e9efbff",
      lightness: 84,
      saturation: 84,
      visibility: "on"
    }
  },
  {
    featureType: "highway",
    elementType: "all",
    stylers: {
      color: "#ff0000ff",
      lightness: 1,
      saturation: 1,
      visibility: "off"
    }
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: {
      color: "#3b7fbaff",
      lightness: 34,
      visibility: "on"
    }
  },
  {
    featureType: "arterial",
    elementType: "all",
    stylers: {
      color: "#1e9efbff",
      lightness: 84,
      saturation: 84,
      visibility: "on"
    }
  },
  {
    featureType: "railway",
    elementType: "all",
    stylers: {
      color: "#1e9efbff",
      lightness: 84,
      saturation: 84,
      visibility: "on"
    }
  },
  {
    featureType: "education",
    elementType: "all",
    stylers: {
      color: "#51fb99ff",
      lightness: 53
    }
  },
  {
    featureType: "educationlabel",
    elementType: "labels",
    stylers: {
      color: "#73b1fbff",
      weight: "8",
      lightness: -2,
      visibility: "on"
    }
  },
  {
    featureType: "subway",
    elementType: "all",
    stylers: {
      color: "#1e9efbff",
      lightness: 84,
      saturation: 84,
      visibility: "on"
    }
  },
  {
    featureType: "subwaystation",
    elementType: "all",
    stylers: {
      color: "#1e9efbff",
      lightness: 84,
      saturation: 84
    }
  }
];
// [
//     {
//       featureType: 'water',
//       elementType: 'all',
//       stylers: {
//         color: '#021019',
//       },
//     },
//     {
//       featureType: 'highway',
//       elementType: 'geometry.fill',
//       stylers: {
//         color: '#000000',
//       },
//     },
//     {
//       featureType: 'highway',
//       elementType: 'geometry.stroke',
//       stylers: {
//         color: '#147a92',
//       },
//     },
//     {
//       featureType: 'arterial',
//       elementType: 'geometry.fill',
//       stylers: {
//         color: '#000000',
//       },
//     },
//     {
//       featureType: 'arterial',
//       elementType: 'geometry.stroke',
//       stylers: {
//         color: '#0b3d51',
//       },
//     },
//     {
//       featureType: 'local',
//       elementType: 'geometry',
//       stylers: {
//         color: '#000000',
//       },
//     },
//     {
//       featureType: 'land',
//       elementType: 'all',
//       stylers: {
//         color: '#08304b',
//       },
//     },
//     {
//       featureType: 'railway',
//       elementType: 'geometry.fill',
//       stylers: {
//         color: '#000000',
//       },
//     },
//     {
//       featureType: 'railway',
//       elementType: 'geometry.stroke',
//       stylers: {
//         color: '#08304b',
//       },
//     },
//     {
//       featureType: 'subway',
//       elementType: 'geometry',
//       stylers: {
//         lightness: -70,
//       },
//     },
//     {
//       featureType: 'building',
//       elementType: 'geometry.fill',
//       stylers: {
//         color: '#000000',
//       },
//     },
//     {
//       featureType: 'all',
//       elementType: 'labels.text.fill',
//       stylers: {
//         color: '#857f7f',
//       },
//     },
//     {
//       featureType: 'all',
//       elementType: 'labels.text.stroke',
//       stylers: {
//         color: '#000000',
//       },
//     },
//     {
//       featureType: 'building',
//       elementType: 'geometry',
//       stylers: {
//         color: '#022338',
//       },
//     },
//     {
//       featureType: 'green',
//       elementType: 'geometry',
//       stylers: {
//         color: '#062032',
//       },
//     },
//     {
//       featureType: 'boundary',
//       elementType: 'all',
//       stylers: {
//         color: '#1e1c1c',
//       },
//     },
//     {
//       featureType: 'manmade',
//       elementType: 'geometry',
//       stylers: {
//         color: '#022338',
//       },
//     },
//     {
//       featureType: 'poi',
//       elementType: 'all',
//       stylers: {
//         visibility: 'off',
//       },
//     },
//     {
//       featureType: 'all',
//       elementType: 'labels.icon',
//       stylers: {
//         visibility: 'off',
//       },
//     },
//     {
//       featureType: 'town',
//       elementType: 'labels.text.fill',
//       stylers: {
//         color: '#2da0c6',
//         visibility: 'on',
//       },
//     },
//   ]
export default json;
